module.exports = __webpack_public_path__ + "static/media/focus.b5c86c61.png";